import React, { useState } from "react";
import { Modal, Button, Alert, Form } from "react-bootstrap";
import Select, { components } from "react-select";
import ServiceSearchRdv from "./ServiceSearchRdv/ServiceSearchRdv";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import "./ModalPeAcharger.css";
import moment from "moment";
import Navbar from "../Navbar/Navbar";
import fr from "date-fns/locale/fr";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
// pick a date util library
import DateFnsUtils from "@date-io/date-fns";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

const ModalPeAcharger = (props) => {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const data = [{ label: "enfant" }, { label: "parant" }];
  const [selectedDate, handleDateChange] = useState(new Date());
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cin, setCin] = useState("");
  const [type, setType] = useState("Enfant");
  const { show, Toggle } = props;

  // added
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const [typeC, setTaypeCs] = useState(
    JSON.parse(sessionStorage.getItem("Type")) &&
      JSON.parse(sessionStorage.getItem("Type")).type
  );

  const handleClose = () => {
    setOpen(false);
    // props.Toggle();
  };

  const HandelClick = () => {
    sessionStorage.setItem(
      "personAcharge",
      JSON.stringify([{ selectedDate, firstName, lastName, type, cin }])
    );
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>

      <Modal show={show} onHide={Toggle}>
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={() => {
              props.Toggle();
            }}
          />
          <h4
            style={{
              marginTop: "27px",
              marginBottom: "18px",
              textAlign: "center",
            }}
          >
            Personne à charge
          </h4>
          <Form.Group>
            <Form.Label>Nom :</Form.Label>
            <Form.Control
              type="text"
              placeholder="Entrer le Nom"
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Prénom :</Form.Label>
            <Form.Control
              type="text"
              placeholder="Entrer le Prénom"
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date Naissance :</Form.Label>
            <br />
            <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
              <KeyboardDatePicker
                format="dd/MM/yyyy"
                autoOk
                variant="inline"
                inputVariant="outlined"
                InputAdornmentProps={{ position: "start" }}
                value={selectedDate}
                onChange={handleDateChange}
              />
            </MuiPickersUtilsProvider>
          </Form.Group>
          <Form.Group controlId="calendar.SelectCustom">
            <Form.Label>Personne à charge :</Form.Label>
            <Form.Control
              as="select"
              custom
              required
              defaultValue="enfant"
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <option>Enfant</option>
              <option>Parent</option>
              <option>époux/épouse</option>
            </Form.Control>
          </Form.Group>
          {(type === "époux/épouse" || type === "Parent") && (
            <Form.Group>
              <Form.Label>Cin :</Form.Label>
              <Form.Control
                type="text"
                placeholder="Entrer le Cin"
                onChange={(e) => {
                  setCin(e.target.value);
                }}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn2 home buttonModal"
            onClick={() => {
              HandelClick();
              props.Toggle();
            }}
            style={{
              marginRight: "155px",
              width: "200px",
              background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
            }}
          >
            Ajouter
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalPeAcharger;
